import ITokenData from '@/models/auth/ITokenData';
import WebEnvConfig from '@/models/WebEnvConfig';
import BaseApiService from '@/services/BaseApiService';
import ServiceHelperFactory from './2.6/ServiceHelperFactory';
import IServiceHelper from './IServiceHelper';

export default class AuthTokenService extends BaseApiService {
    constructor(webEnvConfig: WebEnvConfig) {
        super(webEnvConfig.urls?.authTokenApi ?? '');
    }

    getServiceHelper(): IServiceHelper {
        return ServiceHelperFactory.getHelper();
    }

    async issueQuickSource(username: string | undefined, password: string | undefined): Promise<ITokenData> {
        let result: ITokenData = {};
        this.setIncludeAuthorization(false);
        this.addAcceptJsonHeader();
        this.addHeaders({
            'alm-username': `${username}`,
            'alm-password': `${password}`
        });

        const response = await this.axiosInstance.get('v3.0/Jwt/Issue/QuickSource');
        if (response.data) {
            result = response.data;
        }
        return result;
    }

    async refreshPassQuickSource(refreshToken: string): Promise<ITokenData> {
        let result: ITokenData = {};
        this.setIncludeAuthorization(false);
        this.addAcceptJsonHeader();

        const response = await this.axiosInstance.get('v3.0/Jwt/RefreshPass/QuickSource', {
            params: {
                refreshToken: `${refreshToken}`
            }
        });
        if (response.data) {
            result = response.data;
        }
        return result;
    }
}
